import { Box, BoxProps, ColorOptions, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { colors } from '../../util/colors'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'

interface ButtonProps {
  onPress: () => void
  title: string
  color?: ColorOptions
  disabled?: boolean
  isFull?: boolean
  width?: number | undefined | any
}

const Button: FC<ButtonProps> = ({ onPress, title, color = 'WHITE', disabled, isFull = false, width }: ButtonProps) => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  const style = styles(viewPortWidth)
  return (
    <Box
      {...style.container(isFull)}
      borderColor={color}
      borderWidth={isMobile ? 1 : 2}
      onPress={onPress}
      hoverColor={colors.HOVER_SOLID as ColorOptions}
      width={width}
      underlayColor="TRANSPARENT"
      disabled={disabled}>
      <Text textAlign="center" color={color} fontFamily="jiotype-bold">
        {title}
      </Text>
    </Box>
  )
}

export const ButtonP: FC<ButtonProps> = ({ onPress, title, disabled = false, isFull = false, width }: ButtonProps) => {
  const viewPortWidth = useWindowDimensions()
  const style = styles(viewPortWidth)

  return (
    <Box
      width={width}
      {...style.containerPrimary(isFull, disabled)}
      onPress={onPress}
      underlayColor="PRIMARY"
      disabled={disabled}>
      <Text textAlign="center" color="WHITE" fontFamily="jiotype-medium">
        {title}
      </Text>
    </Box>
  )
}

const styles = (breakpoint: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  return {
    container: (isFull: boolean) =>
      ({
        alignSelf: isFull ? 'stretch' : 'flex-start',
        paddingHorizontal: isTab ? 16 : isMobile ? 24 : 32,
        paddingVertical: 14,
        borderColor: 'WHITE',
        borderWidth: 3,
        borderRadius: 8,
      } as BoxProps),
    containerPrimary: (isFull: boolean, disabled: boolean) =>
      ({
        alignSelf: isFull ? 'stretch' : 'flex-start',
        paddingHorizontal: isTab ? 16 : isMobile ? 24 : 32,
        paddingVertical: 16,
        backgroundColor: colors.HIGHLIGHT,
        opacity: disabled ? 0.5 : 1,
        borderRadius: 8,
      } as BoxProps),
  }
}

export default Button
